import { useEffect, useState, useContext } from "react";
import { productData } from "../Constant/ConstantRegister";
import { SupplierData } from "../Suppliers/SupplierTable";
import styles from "./Order.module.css";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";

export type OrderProduct = {
  productname: string;
  left_right: string;
  size: string;
  color: string;
  cost: number;
  quantity: number;
};

export type OrderData = {
  office: string;
  supplier: string;
  order: OrderProduct[];
  price: number;
  user: string | null;
  reservation_id?: number[];
};

type setSize = {
  size: string[];
};
type setLeftRight = {
  leftright: string[];
};
type setColor = {
  color: string[];
};

export default function Order() {
  const navigate = useNavigate();
  const [selectSupplier, setSelectSupplier] = useState<SupplierData[]>([]);
  const [selectedSupplier, setSelectedSupplier] = useState<string>("");
  const [products, setProducts] = useState<productData[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<string>("");
  const [productData, setProductData] = useState<productData[]>([]);
  const [selectLR, setSelectLR] = useState<setLeftRight[]>([]);
  const [selectedLR, setSelectedLR] = useState<string[]>([]);
  const [selectSize, setSelectSize] = useState<setSize[]>([]);
  const [selectedSize, setSelectedSize] = useState<string[]>([]);
  const [selectColor, setSelectColor] = useState<setColor[]>([]);
  const [selectedColor, setSelectedColor] = useState<string[]>([]);
  const [inputedQuantityString, setInputedQuantityString] = useState<string[]>(
    []
  );
  const [inputedQuantity, setInputedQuantity] = useState<number[]>([]);
  const { auth, setAuth } = useContext(AuthContext) as AuthContextType;
  const [selectedOffice, setSelectedOffice] = useState<string>(
    auth.office ? auth.office : ""
  );
  const [reservation_id, setReservation_id] = useState<number[]>([]);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${baseUrl}/checkAuth`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (!data.result) {
          console.log("Not authenticated");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        const response2 = await fetch(`${baseUrl}/getusersdata`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: data.username }),
        });
        const data2 = await response2.json();
        console.log(
          "Authenticated user:",
          data.username,
          "Office:",
          data2.office,
          "Authority:",
          data2.authority
        );
        setAuth({
          username: data.username,
          isAuthenticated: true,
          office: data2.office,
          authority: data2.authority,
        });
      } catch (error) {
        console.error(error);
      }
    };
    checkAuth();
  }, [navigate, setAuth]);

  useEffect(() => {
    const fetchSelectInit = async () => {
      const response = await fetch(`${baseUrl}/getsupplier`, {
        method: "GET",
        credentials: "include",
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      setSelectSupplier(data);
    };
    fetchSelectInit();
  }, [navigate, setAuth]);

  useEffect(() => {
    const fetchProducts = async () => {
      const response = await fetch(`${baseUrl}/getproducts_supplier`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ supplier: selectedSupplier }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      setProducts(data);
    };
    fetchProducts();
  }, [selectedSupplier, navigate, setAuth]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (!selectedProduct) {
        return;
      }
      const selectedProductData = products.find(
        (item) => item.productname === selectedProduct
      );
      const product_id = selectedProductData?.product_id;
      const response = await fetch(`${baseUrl}/productdata`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ product_id: product_id }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        alert("セッションが切れました。再度ログインしてください");
        setAuth({
          username: null,
          isAuthenticated: false,
          office: undefined,
          authority: "user",
        });
        return navigate("/login");
      }
      setProductData((prev) => [...prev, data]);
      setSelectLR((prev) => [...prev, { leftright: data.leftright }]);
      setSelectSize((prev) => [...prev, { size: data.size }]);
      setSelectColor((prev) => [...prev, { color: data.color }]);
      setSelectedLR((prev) => [...prev, data.leftright[0]]);
      setSelectedSize((prev) => [...prev, data.size[0]]);
      setSelectedColor((prev) => [...prev, data.color[0]]);
      setInputedQuantity((prev) => [...prev, 1]);
      setInputedQuantityString((prev) => [...prev, "1"]);
      setSelectedProduct("");
    };
    fetchProducts();
  }, [selectedProduct, products, navigate, setAuth]);

  const handleOffice = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOffice(e.target.value);
  };

  const handleSupplier = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSupplier(e.target.value);
  };

  const handleProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProduct(e.target.value);
  };

  const handleLR = (e: React.ChangeEvent<HTMLSelectElement>, index: number) => {
    let newArray = [...selectedLR];
    const newLR = e.target.value;
    newArray.splice(index, 1, newLR);
    setSelectedLR(newArray);
  };

  const handleSize = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    let newArray = [...selectedSize];
    const newSize = e.target.value;
    newArray.splice(index, 1, newSize);
    setSelectedSize(newArray);
  };

  const handleColor = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    let newArray = [...selectedColor];
    const newColor = e.target.value;
    newArray.splice(index, 1, newColor);
    setSelectedColor(newArray);
  };

  const handleQuantity = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    let newArrayString = [...inputedQuantityString];
    const newQuantityString = e.target.value;
    newArrayString.splice(index, 1, newQuantityString);
    setInputedQuantityString(newArrayString);
    let newArray = [...inputedQuantity];
    const newQuantity = Number(e.target.value);
    newArray.splice(index, 1, newQuantity);
    setInputedQuantity(newArray);
  };

  const resetOffice = () => {
    setSelectedOffice("");
  };

  const resetOrder = () => {
    setSelectedSupplier("");
    setProductData([]);
    setSelectLR([]);
    setSelectSize([]);
    setSelectColor([]);
    setSelectedLR([]);
    setSelectedSize([]);
    setSelectedColor([]);
    setInputedQuantity([]);
    setSelectedProduct("");
  };

  const AddShortage = async () => {
    const response = await fetch(`${baseUrl}/getshortage`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        office: selectedOffice,
        supplier: selectedSupplier,
      }),
    });
    const data = await response.json();
    const shortage = data.shortage;

    if (shortage.isAuth === false) {
      alert("セッションが切れました。再度ログインしてください");
      setAuth({
        username: null,
        isAuthenticated: false,
        office: undefined,
        authority: "user",
      });
      return navigate("/login");
    }
    // 被りがないかを判定して被りがあった場合加算する処理
    let newQuantity = [...inputedQuantity];
    for (let i = 0; shortage.length > i; i++) {
      let found = false;
      for (let j = 0; productData.length > j; j++) {
        if (
          shortage[i].productData.productname === productData[j].productname &&
          shortage[i].left_right === selectedLR[j] &&
          shortage[i].size === selectedSize[j] &&
          shortage[i].color === selectedColor[j]
        ) {
          newQuantity.splice(j, 1, inputedQuantity[j] + shortage[i].shortage);
          found = true;
          break;
        }
      }
      if (found) {
        continue;
      }
      setProductData((prev) => [...prev, shortage[i].productData]);
      setSelectLR((prev) => [
        ...prev,
        { leftright: shortage[i].productData.leftright },
      ]);
      setSelectSize((prev) => [
        ...prev,
        { size: shortage[i].productData.size },
      ]);
      setSelectColor((prev) => [
        ...prev,
        { color: shortage[i].productData.color },
      ]);
      setSelectedLR((prev) => [...prev, shortage[i].left_right]);
      setSelectedSize((prev) => [...prev, shortage[i].size]);
      setSelectedColor((prev) => [...prev, shortage[i].color]);
      newQuantity.push(shortage[i].shortage);
      setReservation_id(data.reservation_id);
      setSelectedProduct("");
    }
    setInputedQuantity(newQuantity);
    const stringNewQuantity = newQuantity.map((quantity) => String(quantity));
    setInputedQuantityString(stringNewQuantity);
  };

  let total = 0;
  for (let i = 0; productData.length > i; i++) {
    total += productData[i].cost * inputedQuantity[i];
  }

  const cancel = (index: number) => {
    let newData = [...productData];
    newData.splice(index, 1);
    setProductData(newData);
    let newLR = [...selectLR];
    newLR.splice(index, 1);
    setSelectLR(newLR);
    let newSize = [...selectSize];
    newSize.splice(index, 1);
    setSelectSize(newSize);
    let newColor = [...selectColor];
    newColor.splice(index, 1);
    setSelectColor(newColor);
    let newSelectedLR = [...selectedLR];
    newSelectedLR.splice(index, 1);
    setSelectedLR(newSelectedLR);
    let newSelectedSize = [...selectedSize];
    newSelectedSize.splice(index, 1);
    setSelectedSize(newSelectedSize);
    let newSelectedColor = [...selectedColor];
    newSelectedColor.splice(index, 1);
    setSelectedColor(newSelectedColor);
    let newQuantity = [...inputedQuantity];
    newQuantity.splice(index, 1);
    setInputedQuantity(newQuantity);
  };

  const handleOrderPush = async () => {
    const selectedSupplierData = selectSupplier.find(
      (item) => item.supplier === selectedSupplier
    );
    if (!selectedSupplierData?.email)
      return alert("選択した発注先にメールアドレスが設定されていません。");
    if (productData.length < 1) {
      return alert(
        "製品が選択されていません。注文する製品を選択してください。"
      );
    }
    for (let i = 0; productData.length > i; i++) {
      if (inputedQuantity[i] < 1) {
        return alert("個数が0以下に設定されている製品があります。");
      }
      for (let j = i + 1; productData.length > j; j++) {
        if (
          productData[i].productname === productData[j].productname &&
          selectedLR[i] === selectedLR[j] &&
          selectedSize[i] === selectedSize[j] &&
          selectedColor[i] === selectedColor[j]
        ) {
          return alert(
            "製品の規格に重複があります。削除するか変更してください。"
          );
        }
      }
    }

    let order = [];
    for (let i = 0; productData.length > i; i++) {
      const orderProduct: OrderProduct = {
        productname: productData[i].productname,
        left_right: selectedLR[i],
        size: selectedSize[i],
        color: selectedColor[i],
        cost: productData[i].cost,
        quantity: inputedQuantity[i],
      };
      order.push(orderProduct);
    }
    const orderData: OrderData = {
      office: selectedOffice,
      supplier: selectedSupplier,
      order: order,
      price: total,
      user: auth.username,
      reservation_id: reservation_id,
    };
    navigate("/Orderconfirm", { state: orderData });
  };

  const handleOrderInfo = async () => {
    if (productData.length < 1) {
      return alert(
        "製品が選択されていません。注文する製品を選択してください。"
      );
    }
    for (let i = 0; productData.length > i; i++) {
      if (inputedQuantity[i] < 1) {
        return alert("個数が0以下に設定されている製品があります。");
      }
      for (let j = i + 1; productData.length > j; j++) {
        if (
          productData[i].productname === productData[j].productname &&
          selectedLR[i] === selectedLR[j] &&
          selectedSize[i] === selectedSize[j] &&
          selectedColor[i] === selectedColor[j]
        ) {
          return alert(
            "製品の規格に重複があります。削除するか変更してください。"
          );
        }
      }
    }

    let order = [];
    for (let i = 0; productData.length > i; i++) {
      const orderProduct: OrderProduct = {
        productname: productData[i].productname,
        left_right: selectedLR[i],
        size: selectedSize[i],
        color: selectedColor[i],
        cost: productData[i].cost,
        quantity: inputedQuantity[i],
      };
      order.push(orderProduct);
    }
    const orderData: OrderData = {
      office: selectedOffice,
      supplier: selectedSupplier,
      order: order,
      price: total,
      user: auth.username,
      reservation_id: reservation_id,
    };
    const response = await fetch(`${baseUrl}/orderinfo`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(orderData),
    });
    const data = await response.json();
    if (data.isAuth === false) {
      alert("セッションが切れました。再度ログインしてください");
      setAuth({
        username: null,
        isAuthenticated: false,
        office: undefined,
        authority: "user",
      });
      return navigate("/login");
    }
    alert(data.message);
    navigate("/history");
  };

  return (
    <div className={styles.div}>
      <h2 className={styles.h2}>発注テーブル</h2>
      <p className={styles.p}>発注者：{auth.username}</p>
      {auth.office ? (
        <p className={styles.p2}>{auth.office}</p>
      ) : !selectedOffice ? (
        <div>
          <p className={styles.p}>発注元の支店を選択してください。</p>
          <select
            onChange={handleOffice}
            value={selectedOffice}
            className={styles.select}
          >
            <option value="" hidden>
              支店
            </option>
            <option value="函館店">函館店</option>
            <option value="札幌店">札幌店</option>
            <option value="室蘭店">室蘭店</option>
            <option value="釧路店">釧路店</option>
          </select>
        </div>
      ) : (
        <div className={styles.reset}>
          <h3 className={styles.h3}>発注元：{selectedOffice}</h3>
          <Button
            onClick={resetOffice}
            variant="contained"
            sx={{
              fontSize: 16,
              "@media screen and (max-width:959px)": { fontSize: 12 },
            }}
          >
            支店を変更する
          </Button>
        </div>
      )}
      {!selectedSupplier ? (
        <div>
          <p className={styles.p}>発注先を選択してください。</p>
          <select
            value={selectedSupplier}
            onChange={handleSupplier}
            className={styles.select}
          >
            <option value="" hidden>
              発注先
            </option>
            {selectSupplier.map((item, index) => (
              <option key={index} value={item.supplier}>
                {item.supplier}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div className={styles.reset}>
          <h3 className={styles.h3}>発注先：{selectedSupplier}</h3>
          <Button
            onClick={resetOrder}
            variant="contained"
            sx={{
              fontSize: 16,
              "@media screen and (max-width:959px)": { fontSize: 12 },
            }}
          >
            発注先を変更する
          </Button>
        </div>
      )}
      {selectedOffice && selectedSupplier ? (
        <Button
          onClick={AddShortage}
          variant="contained"
          sx={{
            fontSize: 16,
            "@media screen and (max-width:959px)": { fontSize: 12 },
          }}
        >
          在庫不足分を追加する
        </Button>
      ) : null}
      <div className={styles.scroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>製品名</th>
              <th className={styles.th}>左右</th>
              <th className={styles.th}>サイズ</th>
              <th className={styles.th}>色</th>
              <th className={styles.th}>単価</th>
              <th className={styles.th}>数量</th>
              <th className={styles.th}>価格</th>
            </tr>
          </thead>
          <tbody>
            {productData.map((item, index) => (
              <tr key={index}>
                <td className={styles.td}>{item.productname}</td>
                <td className={styles.td}>
                  <select
                    key={index}
                    value={selectedLR[index]}
                    onChange={(e) => handleLR(e, index)}
                    required
                    className={styles.select}
                  >
                    {" "}
                    {selectLR[index].leftright.map((item2, index2) => (
                      <option key={index2} value={item2}>
                        {item2}
                      </option>
                    ))}
                  </select>
                </td>
                <td className={styles.td}>
                  <select
                    key={index}
                    value={selectedSize[index]}
                    onChange={(e) => handleSize(e, index)}
                    required
                    className={styles.select}
                  >
                    {selectSize[index].size.map((item2, index2) => (
                      <option key={index2} value={item2}>
                        {item2}
                      </option>
                    ))}
                  </select>
                </td>
                <td className={styles.td}>
                  <select
                    key={index}
                    value={selectedColor[index]}
                    onChange={(e) => handleColor(e, index)}
                    required
                    className={styles.select}
                  >
                    {selectColor[index].color.map((item2, index2) => (
                      <option key={index2} value={item2}>
                        {item2}
                      </option>
                    ))}
                  </select>
                </td>
                <td className={styles.td}>{item.cost}</td>
                <td className={styles.td}>
                  <input
                    type="number"
                    onChange={(e) => handleQuantity(e, index)}
                    className={styles.input}
                    value={inputedQuantityString[index]}
                  />
                </td>
                <td className={styles.td}>
                  {item.cost * inputedQuantity[index]}
                </td>
                <td>
                  <Button
                    onClick={() => cancel(index)}
                    variant="outlined"
                    sx={{
                      fontSize: 16,
                      "@media screen and (max-width:959px)": {
                        fontSize: 12,
                        width: 70,
                      },
                    }}
                  >
                    取り消し
                  </Button>
                </td>
              </tr>
            ))}
            <tr>
              <td className={styles.td}>
                {products.length > 0 && (
                  <select
                    value={selectedProduct}
                    onChange={handleProduct}
                    className={styles.select}
                  >
                    <option value="" hidden>
                      製品
                    </option>
                    {products.map((item, index) => (
                      <option key={index} value={item.productname}>
                        {item.productname}
                      </option>
                    ))}
                  </select>
                )}
              </td>
              <td className={styles.td}></td>
              <td className={styles.td}></td>
              <td className={styles.td}></td>
              <td className={styles.td}></td>
              <td className={styles.td}></td>
              <td className={styles.td}></td>
            </tr>
            <tr>
              <td colSpan={6} className={styles.td}>
                発注合計額（税抜）
              </td>
              <td className={styles.td}>{total}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {selectedOffice && selectedSupplier && productData && (
        <Button
          onClick={handleOrderPush}
          variant="contained"
          sx={{
            margin: 1,
            fontSize: 16,
            "@media screen and (max-width:959px)": { fontSize: 12 },
          }}
        >
          発注内容を確定してメールで発注する
        </Button>
      )}
      {selectedOffice && selectedSupplier && productData && (
        <Button
          variant="contained"
          onClick={handleOrderInfo}
          sx={{
            margin: 1,
            fontSize: 16,
            "@media screen and (max-width:959px)": { fontSize: 12 },
          }}
        >
          注文情報を登録する
        </Button>
      )}
    </div>
  );
}
